
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { useQuery } from '@tanstack/react-query';
import { useBusiness } from '@/contexts/BusinessContext';

export function useUserBusiness() {
  const { user } = useAuth();
  const { userBusinessId } = useBusiness();
  
  return useQuery({
    queryKey: ['userBusiness', user?.id, userBusinessId],
    queryFn: async () => {
      if (!user) return null;
      
      const { data, error } = await supabase
        .from('businesses')
        .select('id, name, company_logo, is_active, is_listed')
        .eq('user_id', user.id)
        .maybeSingle();
        
      if (error) {
        console.error('Error fetching user business:', error);
        return null;
      }
      
      return data;
    },
    enabled: !!user
  });
}
